import { render, staticRenderFns } from "./UploadDocument.vue?vue&type=template&id=4c35cad9&"
import script from "./UploadDocument.vue?vue&type=script&lang=js&"
export * from "./UploadDocument.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocument.vue?vue&type=style&index=0&id=4c35cad9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports